<template>
  <b-card no-body>
    
    <b-card-header>
      <b-card-title>Sipariş Adetleri</b-card-title>
      <div class="text-right">
        <b-card-sub-title class="mb-25">
          Yıllık Toplam Sipariş
        </b-card-sub-title>
        <b-card-title>{{ totalAmmount }}</b-card-title>
      </div>
      
    </b-card-header>

    <!-- chart -->
    <b-card-body>
      <chartjs-component-horizontal-bar-chart
        :height="400"
        :data="localData"
        :options="chartjsDataCopy"
        v-if="loadChart"
      />
      <b-card style="height:400px" v-else>
        <div class="loading">
          <div class="effect-1 effects"></div>
          <div class="effect-2 effects"></div>
          <div class="effect-3 effects"></div>
        </div>
      </b-card>
    </b-card-body>
  </b-card>
</template>
<script>
import {
  BCard, BCardBody, BCardHeader, BCardTitle, BCardSubTitle,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import ChartjsComponentHorizontalBarChart from '@components/charts-components/ChartjsComponentHorizontalBarChart.vue'
import chartjsData from '@/components/charts-components/chartjsData'

export default {
  components: {
    BCard,
    BCardBody,
    BCardHeader,
    BCardTitle,
    BCardSubTitle,
    flatPickr,
    ChartjsComponentHorizontalBarChart,
  },
  props: {
    inf_id: {
      type: Number,
    },
    chartData: {
      type: Object,
      default: () => ({}), // Varsayılan boş obje
    },
    loadChart: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      chartjsData,
      chartjsDataCopy: {}, // options kopyası
      localData: {}, // Grafik verisi
    };
  },
  methods: {
    updateChartOptions() {
      const maxTickValue = this.maxTickValue; 
      if(this.chartjsDataCopy.scales){
        this.chartjsDataCopy.scales.xAxes[0].ticks = {
          stepSize: 5,
          min: 0,
          max: maxTickValue,
          fontColor: '#6e6b7b',
          fontSize: 11,
          callback: function (value) {
            return `${value} Adet`; // Değere "TL" ekleniyor
          },
        };
      }
    },
  },
  computed: {
    totalAmmount() {
      if (this.localData.datasets) {
        return (
          this.localData.datasets[0].data.reduce((total, order) => total + order, 0) + ' Adet'
        );
      } else {
        return 'Yükleniyor...';
      }
    },
    maxTickValue() {
      if (this.localData.datasets && this.localData.datasets[0].data.length > 0) {
        const maxDataValue = Math.max(...this.localData.datasets[0].data);
        return Math.ceil(maxDataValue * 1.5 / 1) * 1;
      }
      return 40; // Varsayılan bir değer
    },
  },
  mounted() {
    this.chartjsDataCopy = JSON.parse(JSON.stringify(this.chartjsData.horizontalBarChart.options));

    // Tooltip callback
    this.chartjsDataCopy.tooltips.callbacks = {
      label: function (tooltipItem) {
        return tooltipItem.value + ' Adet';
      },
    };
  },
  watch: {
    chartData: {
      immediate: true,
      deep: true,
      handler(newData) {
        this.localData = newData;
        this.updateChartOptions(); // Güncellenmiş `localData`'ya göre max değeri ayarla
      },
    },
    localData() {
      this.updateChartOptions(); // `localData` değişince grafiği güncelle
    },
  },
};
</script>


<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
